/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_BodyInputs */

const en_error_body = /** @type {(inputs: Error_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again. If it keeps happening, the server log says why.`)
};

const de_error_body = /** @type {(inputs: Error_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versuch es noch einmal. Wenn es wieder passiert, steht der Grund im Server-Log.`)
};

/**
* | output |
* | --- |
* | "Try again. If it keeps happening, the server log says why." |
*
* @param {Error_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const error_body = /** @type {((inputs?: Error_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_error_body(inputs)
	return en_error_body(inputs)
});